import * as tslib_1 from "tslib";
import { DocumentModel } from 'src/app/shared/models/document.model';
import { CHANNEL } from '../../../constants/channel.constants';
import { AppInfoModel } from '../../../models/app-info.model';
import { DeviceInfoModel } from '../../../models/device-info.model';
import { AbreCuentasService } from '../../abre-cuentas/abre-cuentas.service';
import { LoadingService } from '../../loading/loading.service';
import { ParametersService } from '../../parameters/parameters.service';
import { MockAppImplService } from './implementation/mockapp/mockapp-impl.service';
import { PortalOperadorImplService } from './implementation/portaloperador-impl.service';
import { PortalPnImplService } from './implementation/portalpn-impl.service';
import { PortalPnCnImplService } from './implementation/portalpncn-impl.service';
import { SuperappImplService } from './implementation/superapp-impl.service';
var ChannelCommunicatorService = /** @class */ (function () {
    /**
     * Summary      Constructor of the component.
     *
     * @var {AbreCuentasService}  abreCuentasService  Injectable abreCuentasService service.
     */
    function ChannelCommunicatorService(abreCuentasService, parametersService, loading) {
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.loading = loading;
    }
    /**
     * Inicializa el parámetro channelId
     *
     * *Sets up channelId parameter*
     *
     * @param {string} code
     */
    ChannelCommunicatorService.prototype.setChannelId = function (code) {
        this.channelId = code;
        this.abreCuentasService.chanelid = code;
        switch (this.channelId) {
            case CHANNEL.MOCKAPP.CODE:
                this.impl = new MockAppImplService(this.parametersService);
                break;
            case CHANNEL.SUPERAPP.CODE:
                this.impl = new SuperappImplService(this.loading);
                break;
            case CHANNEL.PORTALPN.CODE:
                this.impl = new PortalPnImplService();
                break;
            case CHANNEL.PORTALO.CODE:
                this.impl = new PortalOperadorImplService();
                break;
            case CHANNEL.PORTALPN2.CODE:
                this.impl = new PortalPnCnImplService();
                break;
            case CHANNEL.PORTALALLIES.CODE:
                // this.impl = new PortalAllyImplService();
                break;
        }
    };
    /**
     * Obtiene el parámetro de channelId
     *
     * @returns this.channelId parameter
     */
    ChannelCommunicatorService.prototype.getChannelId = function () {
        return this.channelId;
    };
    /**
     * Obtiene el parámetro de Impl
     *
     * @returns this.Impl parameter
     */
    ChannelCommunicatorService.prototype.getImpl = function () {
        return this.impl;
    };
    /**
     * Valida el canal de comunicación por medio del channel_id, para desarrollo se utiliza el canal 131
     *
     * *Verify Channel Communication by the channel_id parameter, To development environment it is used channel 131*
     *
     */
    ChannelCommunicatorService.prototype.validateChannel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url_mock_sdk, channelId, codeAlly;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url_mock_sdk = this.parametersService.getParameter('url_mock_sdk');
                        if (!url_mock_sdk) return [3 /*break*/, 2];
                        this.setChannelId(CHANNEL.MOCKAPP.CODE);
                        return [4 /*yield*/, this.callInfoClient()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        channelId = this.abreCuentasService.getQueryParamByName('channel_id', window.location.search);
                        if (channelId.length > 0) {
                            this.setChannelId(channelId);
                            if (channelId === '163') {
                                codeAlly = this.abreCuentasService.getQueryParamByName('code_ally', window.location.search);
                                this.abreCuentasService.setAllyCode(codeAlly);
                            }
                        }
                        else {
                            this.setChannelId(CHANNEL.SUPERAPP.CODE);
                        }
                        return [4 /*yield*/, this.callInfoClient()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Obtiene e inicializa la información de la Aplicación
     *
     * *Gets and Sets app information*
     */
    ChannelCommunicatorService.prototype.retreiveAndSetAppInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.getImpl().getAppInfo()
                            .then(function (response) {
                            var channelInfo = new AppInfoModel();
                            channelInfo.infoUnavailable = (response.code === '404');
                            channelInfo.channelId = response.data.channelId;
                            channelInfo.platform = response.data.platform;
                            channelInfo.appVersion = response.data.appVersion;
                            _this.abreCuentasService.setAppInfo(channelInfo);
                            resolve('');
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Obtiene e inicializa la información del dispositivo
     *
     * *Gets and Sets device information*
     */
    ChannelCommunicatorService.prototype.retreiveAndSetDeviceInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.getImpl().getDeviceInfo()
                            .then(function (response) {
                            var deviceInfo = new DeviceInfoModel();
                            deviceInfo.device_id = response.data.device.device_id;
                            deviceInfo.brand = response.data.device.brand;
                            deviceInfo.os_version = response.data.device.os_version;
                            deviceInfo.model = response.data.device.model;
                            _this.abreCuentasService.setDeviceInfo(deviceInfo);
                            resolve('');
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Transferencia a enrolamiento
     *
     * *transfer to enlistment*
     */
    ChannelCommunicatorService.prototype.openEnrollment = function (_sesionId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.getImpl()
                            .openPage(_sesionId, 5, false).then(function (response) {
                            console.log('reponse', response);
                            resolve('');
                        });
                    })];
            });
        });
    };
    /**
     * Establece el canal de comunicación de acuerdo al parámetro de channel id
     *
     * *Establishes the communication channel according to channel id parameter*
     */
    ChannelCommunicatorService.prototype.getChannelStyle = function () {
        /* Cambio para bug OE-23063 : Start */
        return this.channelId === CHANNEL.SUPERAPP.CODE ? 'default' : 'portalpn';
        // return this.channelId === CHANNEL.PORTALPN.CODE || this.channelId === CHANNEL.PORTALALLIES.CODE ? 'portalpn' : 'default';
        /* Cambio para bug OE-23063 : End */
    };
    /**
     * Valida la informacion del para identificar si el flujo va por pre o post login
     *
     * *Verify user info to select flow preLogin or postLogin*
     *
     */
    ChannelCommunicatorService.prototype.callInfoClient = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log('canal', this.channelId);
                        _a = this.channelId;
                        switch (_a) {
                            case '163': return [3 /*break*/, 1];
                            case '159': return [3 /*break*/, 2];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        this.abreCuentasService.setPostlogin(false);
                        return [3 /*break*/, 6];
                    case 2: return [4 /*yield*/, this.getImpl().getInfoClient().then(function (_response) {
                            var data = _response.data;
                            _this.abreCuentasService.setSeller(data.document);
                        })];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (this.abreCuentasService.getUserJemelii()) {
                            console.log('canal default is user jemelli');
                            this.abreCuentasService.setPostlogin(false);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getImpl().getInfoClient().then(function (_response) {
                                if (_response.code !== '200') {
                                    _this.abreCuentasService.setPostlogin(false);
                                    return;
                                }
                                var data = _response.data;
                                var documenInfo = new DocumentModel();
                                documenInfo.document_type = data.document.type;
                                documenInfo.document_number = parseInt(data.document.number, 10).toString();
                                _this.abreCuentasService.setDocumentInfo(documenInfo);
                                _this.abreCuentasService.setPostlogin(true);
                            })];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return ChannelCommunicatorService;
}());
export { ChannelCommunicatorService };
